module.exports = __webpack_public_path__ + "img/noimg.3b92c55e.png";